import { Component, Input, ViewChild } from '@angular/core';
import { BaseForm } from '@forms/base.form';
import { Employee } from '@models/employee/employee.model';
import { Feedback } from '@models/performance/feedback.model';

type sentiment = 'positive' | 'constructive' | 'negative';

@Component({
    selector: 'app-form-feedback',
    templateUrl: './feedback.template.html',
    styleUrls: ['./feedback.style.scss'],
})
export class FeedbackForm extends BaseForm {
    @Input() feedback: Feedback = new Feedback({
        positive: true,
        visibility: 'public',
    });
    @Input() profile: Employee = null;
    @ViewChild('form', { static: true }) form;

    constructor() {
        super();
    }

    reset(feedback?: Feedback): void {
        super.reset();
        this.form.resetForm();

        if (feedback) {
            this.feedback = feedback;
            return;
        }

        this.feedback = new Feedback({
            positive: true,
            visibility: 'public',
        });
    }

    updateSentimentToggle(type: sentiment): void {
        switch (type) {
            case 'positive':
                this.feedback.positive = true;
                this.feedback.constructive = false;
                this.feedback.negative = false;
                break;
            case 'constructive':
                this.feedback.positive = false;
                this.feedback.constructive = true;
                this.feedback.negative = false;
                break;
            case 'negative':
                this.feedback.positive = false;
                this.feedback.constructive = false;
                this.feedback.negative = true;
                break;
        }
    }
}
